// Frontend environment loader
// This ensures environment variables are loaded from the root directory

import { getApiBaseUrl, getWsUrl } from './utils/apiBaseUrl';

const getEnvVar = (key, defaultValue = '') => {
  // Try to get from process.env (works in production)
  if (typeof process !== 'undefined' && process.env && process.env[key]) {
    return process.env[key];
  }
  
  // Try to get from import.meta.env (Vite's way)
  if (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env[key]) {
    return import.meta.env[key];
  }
  
  // Try to get from window.__ENV__ (if we set it up)
  if (typeof window !== 'undefined' && window.__ENV__ && window.__ENV__[key]) {
    return window.__ENV__[key];
  }
  
  return defaultValue;
};

// Align with getApiBaseUrl() so /api matches the real backend (port 3001, proxy, etc.)
const defaultApiUrl =
  typeof window !== 'undefined' && window.location ? `${getApiBaseUrl()}/api` : '';
const defaultWsUrl =
  typeof window !== 'undefined' && window.location ? getWsUrl() || '' : '';
export const config = {
  VITE_API_URL: getEnvVar('VITE_API_URL', defaultApiUrl),
  VITE_WS_URL: getEnvVar('VITE_WS_URL', defaultWsUrl),
  VITE_APP_NAME: getEnvVar('VITE_APP_NAME', 'Oakland AI'),
  NODE_ENV: getEnvVar('NODE_ENV', 'development'),
};

// Make config available globally for debugging
if (typeof window !== 'undefined') {
  window.__APP_CONFIG__ = config;
}

export default config; 